import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

/**
 * Architecture — Service 1 of 3: The Blueprint (Mapping the Narrative).
 * Formerly "AI Readiness & Strategic Consulting".
 */
const ArchitectureBlueprint = () => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        THE BLUEPRINT: MAPPING THE NARRATIVE
      </h2>
      <p className="glass-panel__body" data-testid="section-body">
        Before a single line of code is ever committed, we map the entirety
        of your brand&apos;s universe. We are not merely auditing your
        software stack; we are conducting a rigorous examination of the
        fantasy you are selling to your clients. By identifying the precise
        points where operational friction degrades the premium experience,
        we can seamlessly align the underlying mechanics with the distinct
        tone of your marketing.
      </p>
      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
        <Link
          to="/architecture"
          className="glass-panel__btn glass-panel__btn--back"
          data-testid="btn-back"
        >
          Architecture
        </Link>
        <Link
          to="/architecture/engine"
          className="glass-panel__btn glass-panel__btn--right"
          data-testid="btn-next"
        >
          The Engine
        </Link>
      </div>
    </SectionLayout>
  );
};

export default ArchitectureBlueprint;
